export class BrowserUtil {

    static isInAppBrowser(): boolean {
        const ua = navigator.userAgent || navigator.vendor || '';

        const inAppPatterns = [
            /Instagram/i,           // Instagram
            /FBAN|FBAV|FB_IAB|FBIOS|FBSS/i, // Facebook (all variants)
            /Pinterest/i,            // Pinterest
            /TikTok|musical_ly|BytedanceWebview/i, // TikTok
            /Snapchat/i,              // Snapchat
            /LinkedInApp/i,           // LinkedIn
            /Twitter/i,                // Twitter / X
            /Line\//i,                  // Line
            /MicroMessenger/i,           // WeChat
            /WhatsApp/i,                  // WhatsApp
            /Threads/i,                    // Threads (Meta)
            /GSA\//i,                       // Google app (Google Search in-app browser)
            /wv\)/i                          // Generic Android WebView marker
        ];

        return inAppPatterns.some(pattern => pattern.test(ua));
    }

}
